import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { PinpointEmailBaseCampaign } from '@feathr/blackbox';
import { Form } from '@feathr/components';

import EmailCampaignSegments from '../EmailCampaignSegments';

interface IProps {
  campaign: PinpointEmailBaseCampaign;
  disabled: boolean;
}

function AutoPinpointEmailCampaignStepExclusions({ campaign, disabled }: IProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Form
      description={t(
        'Optional: Choose or create an exclusion group(s). Any contact in the selected exclusion group(s) will not be sent this email, even if they perform the trigger.',
      )}
      label={t('Edit Campaign: Exclusions')}
      width={'wide'}
    >
      <EmailCampaignSegments
        campaign={campaign}
        disabled={disabled}
        hideIncluded={true}
        step={4}
        title={t('Group Exclusions')}
      />
    </Form>
  );
}

export default observer(AutoPinpointEmailCampaignStepExclusions);
